module.exports = __webpack_public_path__ + "static/media/underline_long@2x.04ad939a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/underline_long@2x.png
 ** module id = 2010
 ** module chunks = 50
 **/